import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Swal from 'sweetalert2';
import API_URL from '../config/api';

const ContactForm = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    asunto: '',
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post(`${API_URL}/contactos`, {
        asunto: `Contacto General: ${formData.asunto} - Consulta formulario web`,
        nombre: formData.name,
        email: formData.email,
        telefono: formData.phone,
        mensaje: formData.message
      });

      // SweetAlert2 para éxito
      await Swal.fire({
        icon: 'success',
        title: t('contactForm.alert_title'),
        text: t('contactForm.alert_success'),
        confirmButtonText: 'OK',
        confirmButtonColor: '#1E5096',
        background: '#ffffff',
        color: '#333333'
      });

      // Reset form
      setFormData({
        asunto: '',
        name: '',
        email: '',
        phone: '',
        message: ''
      });
    } catch (error) {
      console.error('Error sending contact form:', error);

      // SweetAlert2 para error
      await Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Error enviando el mensaje. Por favor intenta nuevamente.',
        confirmButtonText: 'Intentar de nuevo',
        confirmButtonColor: '#1E5096',
        background: '#ffffff',
        color: '#333333'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container>
      <Row>
        <Col>
          <Form onSubmit={handleSubmit} className="contact-form-spotlight">
            <Form.Group className='continputs' controlId="formBasicSubject">
              <Form.Label>{t('contactForm.interestedIn')}</Form.Label>
              <Form.Control type="text" placeholder={t('contactForm.interestedIn')} name="asunto" value={formData.asunto} onChange={handleChange} required />
            </Form.Group>

            <Form.Group className='continputs' controlId="formBasicName">
              <Form.Label>* {t('contactForm.name')}</Form.Label>
              <Form.Control type="text" placeholder={t('contactForm.name_placeholder')} name="name" value={formData.name} onChange={handleChange} required />
            </Form.Group>

            <Form.Group className='continputs' controlId="formBasicEmail">
              <Form.Label>* {t('contactForm.email')}</Form.Label>
              <Form.Control type="email" placeholder={t('contactForm.email_placeholder')} name="email" value={formData.email} onChange={handleChange} required />
            </Form.Group>

            <Form.Group className='continputs' controlId="formBasicPhone">
              <Form.Label>{t('contactForm.phone')}</Form.Label>
              <Form.Control type="tel" placeholder={t('contactForm.phone_placeholder')} name="phone" value={formData.phone} onChange={handleChange} />
            </Form.Group>

            <Form.Group className='continputs' controlId="formBasicMessage">
              <Form.Label>* {t('contactForm.message')}</Form.Label>
              <Form.Control as="textarea" rows={4} placeholder={t('contactForm.message_placeholder')} name="message" value={formData.message} onChange={handleChange} required />
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Enviando...' : t('contactForm.send_button')}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default ContactForm;
